/**
 * Development-only logging utility.
 *
 * Calls `console.log` only when `import.meta.env.DEV` is true.
 * In production builds Vite replaces the flag with `false`,
 * allowing the bundler to tree-shake the entire call site.
 *
 * Usage:
 *   import { devLog } from '@/utils/logger';
 *   devLog('[myService]', 'some debug info', { id });
 *
 * `console.error` and `console.warn` should still be used
 * directly — those are legitimate production signals.
 */
export const devLog = (...args: unknown[]): void => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};
